// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YWQO","importantInfo":"styles_importantInfo__1hitM"};